import { Box, Button, TextField } from '@mui/material';
import { useState } from 'react';
import { isProduction } from '../utils/constants'
import { isDarkMode, themeColors } from "../utils/constants";
import { useNavigate } from 'react-router-dom';

const asArray = (msg) => Array.isArray(msg) ? msg : (msg ? [String(msg)] : []);

const SignIn = (props) => {
  const {
    // closeModal,
    setGoToChat,
    appProps,
    successRedirectPath,
  } = props

  const navigate = useNavigate()

  const { userData, setUserData, setShowSignUpModal } = appProps

  const [signInParams, setSignInParams] = useState({
    email: isProduction ? "" : "andrew@inciteai.com",
    password: isProduction ? "" : "12345678"
  })
  const [errors, setErrors] = useState([])
  const [twoFARequired, setTwoFARequired] = useState(false)
  const [otpCode, setOtpCode] = useState("")
  const [submittingSignIn, setSubmittingSignIn] = useState(false)
  const [verifyingOtp, setVerifyingOtp] = useState(false)
  const [resendingOtp, setResendingOtp] = useState(false)

  const getSuccessPath = (data) => {
    if (successRedirectPath) {
      return successRedirectPath
    }

    return data.is_email_confirmed ? '/chat' : '/confirm-email'
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    if (submittingSignIn) return

    setSubmittingSignIn(true)
    setErrors([])

    let user = {
      email: signInParams.email,
      password: signInParams.password,
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(user) // Don't need to pass as {user: user} since not looking for params[:user]
    }
    fetch('/login', requestOptions)
      .then(response => {
        return (response.json())
      })
      .then(data => {
        if (data.error_message) {
          setErrors(asArray(data.error_message));
          setTwoFARequired(false);
          return;
        }
        if (data.two_factor_required) {
          // show OTP step; backend saved pending_2fa_user_id in session cookie
          setTwoFARequired(true)
          setErrors([])
          return
        }
        if (data.user_id) {
          setShowSignUpModal(false)
          navigate(getSuccessPath(data))
          setUserData({...userData, ...data, requireSignIn: false, }) //set back to false if they were required to sign in immediately (same IP address user)
          return;
        }
        // Fallback for unexpected response shape
        setErrors(['Unexpected response from server. Please try again.'])
      })
      .catch(error => {
        console.log('api errors:', error)
        setErrors(asArray(error?.message || 'Failed to sign in'))
      })
      .finally(() => {
        setSubmittingSignIn(false)
      })
  }

  const handleVerifyOtp = (e) => {
    e.preventDefault()
    if (verifyingOtp) return

    setVerifyingOtp(true)
    setErrors([])

    fetch('/login/verify_otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: otpCode })
    }).then(r => r.json())
      .then(data => {
        if (data.error_message) { setErrors(asArray(data.error_message)); return }
        // success -> same flow as normal login
        setShowSignUpModal(false)
        navigate(getSuccessPath(data))
        setUserData({...userData, ...data, requireSignIn: false})
      })
      .catch(e => setErrors(asArray(e?.message || 'Failed to verify code')))
      .finally(() => {
        setVerifyingOtp(false)
      })
  }

  const handleResendOtp = () => {
    if (resendingOtp) return

    setResendingOtp(true)
    setErrors([])

    fetch('/login/resend_otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(async (response) => {
        const data = await response.json()
        if (!response.ok || data.error_message) {
          throw new Error(asArray(data.error_message)[0] || 'Failed to resend code')
        }
      })
      .catch((e) => setErrors(asArray(e?.message || 'Failed to resend code')))
      .finally(() => {
        setResendingOtp(false)
      })
  }

  const handleChange = (event) => {
    const {name, value} = event.target
    setSignInParams(signInParams => ({
      ...signInParams,
      [name]: value,
    }))
  }

  return (
  <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    <Box sx={{width: '94%', maxWidth: '350px'}}>
      {!twoFARequired ? (
        <form autoComplete="off" onSubmit={handleSubmit} >
          <Box sx={{color: 'rgb(255,0,0,.6)'}}>
            <ul>{errors.map((error) => {
              return <li key={error}>{error}</li>
              })}
            </ul>
          </Box>

          <Box sx={{display: 'flex', flexDirection: 'column'}}>
            <TextField
              sx={{
                marginBottom: '15px',
                '& .MuiInputBase-input': { // This targets the input itself
                  color: themeColors.color,
                },
                '& .MuiFormLabel-root': { // This targets the label
                  color: themeColors.color,
                },
                '& .MuiOutlinedInput-root': { // This targets the root of the input and the border color
                  color: themeColors.color,
                  '& fieldset': {
                    borderColor: themeColors.color,
                  },
                  '&:hover fieldset': {
                    borderColor: themeColors.color,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: themeColors.color,
                  },
                },
              }}
              inputProps={{ required: true}}
              InputLabelProps={{
                style: {
                  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  fontWeight: '400',
                  color: themeColors.color,
                }}}
              type="email"
              value={signInParams.email}
              onChange={handleChange}
              autoComplete="off"
              name="email"
              label="Email"/>
            <TextField
              sx={{
                marginBottom: '15px',
                '& .MuiInputBase-input': { // This targets the input itself
                  color: themeColors.color,
                },
                '& .MuiFormLabel-root': { // This targets the label
                  color: themeColors.color,
                },
                '& .MuiOutlinedInput-root': { // This targets the root of the input and the border color
                  color: themeColors.color,
                  '& fieldset': {
                    borderColor: themeColors.color,
                  },
                  '&:hover fieldset': {
                    borderColor: themeColors.color,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: themeColors.color,
                  },
                },
              }}
              inputProps={{ minLength: 8, required: true }}
              InputLabelProps={{
                style: {
                  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                  fontWeight: '400',
                  color: themeColors.color,
                },
              }}
              type="password"
              value={signInParams.password}
              onChange={handleChange}
              autoComplete="off"
              name="password"
              label="Password"
            />
            <Box sx={{width: '100%', textAlign: 'center', display: 'flex',  justifyContent: 'center',}}>
            <Box sx={{marginTop: '10px',}}>
              <Button variant="contained" className="i_understand_button" sx={{
                textTransform: 'none',
                borderRadius: '24px',
                background: themeColors.buttonPrimaryColor,
                boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.05)',
                marginTop: '0px',
                transition: 'opacity 0.2s ease-in-out',
                '&:hover': {
                  background: themeColors.buttonPrimaryColor,
                  opacity: 0.7,
                },

              }}
              type="submit"
              disabled={submittingSignIn}
              >
              <Box className="base-text i_understand_text" sx={{
                display: 'flex',
                fontWeight: '500',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                marginTop: '2px',
                color: themeColors.primaryText,
                fontSize: '20px',
              }}>
                {submittingSignIn ? 'Signing In...' : 'Sign In'}
              </Box>
              </Button>
            </Box>
          </Box>
          </Box>
        </form>
      ) : (
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <form autoComplete="off" onSubmit={handleVerifyOtp}>
            {errors.length > 0 && (
              <Box sx={{ color: 'rgb(255,0,0,.6)', mb: 2 }}>
                <ul>{errors.map((error) => <li key={error}>{error}</li>)}</ul>
              </Box>
            )}
            <TextField
              sx={{ marginBottom: '15px',
                ...textFieldStyles
              }}
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 6, required: true }}
              label="6-digit code"
              value={otpCode}
              onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            />
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button variant="contained" type="submit" disabled={verifyingOtp || otpCode.length !== 6}>
                {verifyingOtp ? 'Verifying...' : 'Verify'}
              </Button>
              <Button variant="text" type="button" onClick={handleResendOtp} disabled={resendingOtp}>
                {resendingOtp ? 'Sending...' : 'Resend'}
              </Button>
            </Box>
          </form>
          </Box>
      )}
    </Box>
  </Box>
  )
}

const textFieldStyles = {
  '& .MuiInputBase-input': { color: themeColors.color },
  '& .MuiFormLabel-root': { color: themeColors.color },
  '& .MuiOutlinedInput-root': {
    color: themeColors.color,
    '& fieldset': { borderColor: themeColors.color },
    '&:hover fieldset': { borderColor: themeColors.color },
    '&.Mui-focused fieldset': { borderColor: themeColors.color },
  },
};

export default SignIn
